import React from "react";
import { useTranslation } from "react-i18next";
import { NoData } from "@components/common/NoData/NoData";
import { facultyMemberFieldConfig } from "../institute.config";
import type { FacultyMemberDetails } from "../types/types";
import InstituteDetailsFieldGrid from "./InstituteDetailsFieldGrid";

interface FacultyDetailsStepProps {
	data?: FacultyMemberDetails[];
}

const FacultyDetailsStep: React.FC<FacultyDetailsStepProps> = ({ data }) => {
	const { t } = useTranslation();
	const facultyMembers = data ?? [];

	if (facultyMembers.length === 0) {
		return (
			<div className="space-y-4 p-2">
				<div className="text-xl font-semibold text-gray-800">
					{t("components.instituteDetails.faculty.title")}
				</div>
				<div className="rounded-lg border border-dashed border-gray-300 bg-gray-50/80 px-6 py-10 shadow-inner">
					<NoData msg={t("components.instituteDetails.faculty.noData")} />
				</div>
			</div>
		);
	}

	return (
		<div className="space-y-6 p-2">
			<div className="text-xl font-semibold text-gray-800">{t("components.instituteDetails.faculty.title")}</div>
			{facultyMembers.map((member, index) => {
				const fields = facultyMemberFieldConfig.map(field => ({
					...field,
					value: member[field.name as keyof FacultyMemberDetails]?.toString() || "—",
				}));

				return (
					<section
						key={member.id}
						className="rounded-lg border border-gray-200 bg-white shadow-sm overflow-hidden">
						<div className="border-l-4 border-primary bg-primary/5 px-4 py-3">
							<h3 className="text-base font-semibold text-gray-900">
								{t("components.instituteDetails.faculty.memberTitle", { number: index + 1 })}
								{member.name !== "—" ? (
									<span className="ml-2 font-medium text-gray-600">— {member.name}</span>
								) : null}
							</h3>
						</div>
						<div className="p-4">
							<InstituteDetailsFieldGrid fields={fields} />
						</div>
					</section>
				);
			})}
		</div>
	);
};

export default FacultyDetailsStep;
